export default __webpack_public_path__ + "static/media/baigneur.c5c7f9e1.jpg";